@use "../../styles/breakpoint.module.scss" as *;

.nav {
    composes: container from "../../styles/composable/layout.module.css";
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--spacer-48);
    gap: var(--spacer-24);

    @media ($below-mobile) {
        flex-direction: column;
    }
}

.title {
    composes: fontHeader34 from "../../styles/composable/typography.module.css";
}

.breadcrumbs {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    margin-top: var(--spacer-16);

    li:not(:last-child) {
        &::after {
            content: "›";
            padding-inline: var(--spacer-16);
        }
    }
}

.input,
.input input {
    width: 300px;
    max-width: 100%;
}
